import { useQuery } from "react-query";
import axiosClient from "../../lib/axios";
import { useCallback, useEffect, useState } from "react";
import SelectWithModal from "../SelectWithModal";
import useDebounce from "../../lib/useDebounce";

export default function SelectQuery({
    defaultValue,
    onChange,
    label,
    type,
    titleModal,
    getLabel,
    query,
    emptyLabel = "",
    disabled = false,
    multiple = false,
    returnOnlyId = true,
    autoSelectFirst = false,
    fullWidthInput = false,
    extraParams = {},
    permitirLimpar = true
}: SelectQueryProps) {

    const [values, setValues] = useState(defaultValue || []);
    const [filter, setFilter] = useState({
        keyword: "",
        limit: 100
    });

    const debouncedKeyword = useDebounce(filter.keyword)

    const { data, isFetching } = useQuery({
        queryKey: [query, filter.limit, debouncedKeyword, extraParams],
        queryFn: () => axiosClient.get(query, {
            params: {
                pesquisar: debouncedKeyword,
                limit: filter.limit,
                ...extraParams
            }
        }),
        keepPreviousData: true,
        cacheTime: 0,
        retry: false
    });

    const handleChangeFilter = useCallback((prop: "keyword" | "limit", value: string | number) => {
        setFilter(prevState => ({
            ...prevState,
            [prop]: value
        }))
    }, [])

    useEffect(() => {
        if (data?.data.total > 0 && autoSelectFirst && values.length === 0) {
            setValues([data?.data.data[0]])
            onChange([data?.data.data[0]])
        }
    }, [data])

    return (
        <SelectWithModal
            options={data?.data.data}
            defaultSelected={values}
            totalData={data?.data.total || 0}
            limitData={data?.data.limit || filter.limit}
            getLabel={getLabel || ((option: any) => `${option.id ? `${option.id} - ` : ""}${option.nome}`)}
            onChange={(values) => {
                if (returnOnlyId) {
                    onChange(values.map(i => i.id))
                    return
                }
                onChange(values)
            }}
            onClear={() => onChange([])}
            onEdgeReached={() => handleChangeFilter("limit", filter.limit + 100)}
            onKeywordChange={(value: string) => handleChangeFilter("keyword", value)}
            {...{ isFetching, multiple, titleModal, type, label, emptyLabel, disabled, fullWidthInput, permitirLimpar }}
        />
    );
}


interface SelectQueryProps {
    query: string,
    label: string
    type: "field" | "icon"
    titleModal: string
    emptyLabel?: string
    onChange: (values: any[]) => void;
    multiple: boolean;
    getLabel?: (option: any) => string;
    autoSelectFirst?: boolean;
    returnOnlyId?: boolean
    disabled?: boolean
    fullWidthInput?: boolean
    defaultValue?: ({
        id: number;
        nome: string;
    }[] | undefined) | "all" | "first";
    extraParams?: any
    permitirLimpar?: boolean
}
